import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { IEpGridModel, EpGridEvent, IEpGridSelectionOptions, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig } from 'ep-bt-controls';
import { FieldAgentClient, PagingParameters, SortParameters, BranchAccessLevel } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
import { IEpBtFaCardModel } from '../../models/epbt-fa-card.model';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-binlocation-grid',
  templateUrl: './epbt-fa-product-binlocation-grid.component.html',
  styleUrls: ['./epbt-fa-product-binlocation-grid.component.scss']
})

export class EpbtFaProductBinlocationGridComponent implements OnInit {
  @Input() productId: number;

  // Grid Properties start
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public card: Array<IEpBtFaCardModel>;
  paging: PagingParameters;
  sort: SortParameters;
  binLocations: any = [];
  @ViewChild('binTemplate', {static: false}) binTemplate: TemplateRef<any>;
  // Grid Properties end

  constructor(private binLocationService: EpbtFaProductBinlocationService, private client: FieldAgentClient,
    private router: Router, private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig, private productService: EpbtFaProductService) { }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });
    this.gridModel = this.getGridModel();
    this.getGridData();
  }

  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'branchID',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: this.binLocations,
      columns: [
        { field: 'branch.code', title: 'CODE', width: 30, hidden: false },
        { field: 'branch.name', title: 'NAME', width: 30, hidden: false },
        { field: 'bins', title: 'BIN(S)', width: 30, hidden: false, cellTemplate: this.binTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToDetailsView(eventArg.event.dataItem);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToDetailsView(args.dataItem);
      //   }
      // },
    };
    return model;
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }

  getGridData() {
    this.binLocationService.getBinLocations(this.productId, this.config.getLoggedinUser(), BranchAccessLevel.Read,
      (binLocationsRes: any) => {
        this.binLocations = binLocationsRes;
        this.gridModel.data = this.binLocations;
      });
  }

  updateGridData() {
    this.getGridData();
  }

  navigateToDetailsView(args) {
    this.binLocationService.clearData(this.productService.fromPage);
    this.binLocationService.selectedBinLocation = args;
    this.binLocationService.selectedBranchId = args.branch.branchID;
    this.binLocationService.selectedBinLocation.bins = args.bins;
    this.binLocationService.fromDashbard = false;
    const selectedProduct = this.productService.selectedProductItem;
    selectedProduct.dateTimeLastModified = this.fieldAgentService.convertToUtc(new Date());
    selectedProduct.dateTimeCreated = this.fieldAgentService.convertToUtc(new Date());
    selectedProduct.binLocations = this.binLocationService.selectedBinLocation.bins.join(',');
    this.binLocationService.selectedProducts.push(selectedProduct);
    this.router.navigate(['/home/binlocations']);
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }

  concatBins(bins: any): string {
    let finalString = '';
    if (bins) {
      for (let i = 0; i < bins.length; i++) {
        if (i < bins.length - 1) {
          finalString = finalString + bins[i] + ', ';
        } else {
          finalString = finalString + bins[i];
        }
        const num = bins[i];
      }
    }
    return finalString;
  }
}
